import React from 'react';
import Deposit from './deposit.jsx';

const Index = () => {

	return(

		<Deposit />

	)

}

export default Index;